export default function LabelBoxIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.8341 18.5271V9.52706L3.28711 4.99889L10.0008 0.970703L17.5008 5.4707V14.5271L10.8341 18.5271Z"
        fill="currentColor"
      />
      <path
        d="M2.5 14.5299V6.47363L5 7.97363V12.9736L9.16667 15.4736V18.5299L2.5 14.5299Z"
        fill="currentColor"
      />
    </svg>
  );
}
